export default {"src":"/_next/static/media/chemistryBg.d6e22289.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};